import moment from 'moment'
import * as kurenotori from './counselor/kurenotori/counselorInfos'
import * as kanoucoco from './counselor/kanoucoco/counselorInfos'
import * as touwa from './counselor/touwa/counselorInfos'
import * as houen from './counselor/houen/counselorInfos'
import * as ottimo from './counselor/ottimo/counselorInfos'
import * as somarimone from './counselor/somarimone/counselorInfos'

const COLLECTION_ICONS_DIR = '/static/img/recommend/lp/common/collection_icons/'

export const BASIC_DATA = {
  kurenotori,
  kanoucoco,
  touwa,
  houen,
  ottimo,
  somarimone,
}

export const BASIC_DATA_BY_LPID = [ null,
  BASIC_DATA.kurenotori,
  BASIC_DATA.kanoucoco,
  BASIC_DATA.touwa,
  BASIC_DATA.houen,
  BASIC_DATA.ottimo,
  BASIC_DATA.somarimone,
]

export const DEFAULT_FOOTER_MENULIST = [
  { label: 'よくある質問', url: '/faq' },
  { label: 'お問い合わせ', url: '/help/inquiry' },
  { label: 'プライバシーポリシー', url: '/privacy' },
  { label: '利用規約', url: '/terms' },
  { label: 'Cookie利用について', url: '/cookie' },
  { label: '特定商取引法に基づく表記', url: '/legal' },
  { label: '運営会社', url: 'https://www.zappallas.com/' }
]

export const COLLECTION_ICONS = [
  null,
  { url: `${COLLECTION_ICONS_DIR}icon_collection1.png`, description: 'その恋が叶う必然性', sort: 1, },
  { url: `${COLLECTION_ICONS_DIR}icon_collection2.png`, description: '転職すれば、<br>お給料は上がりますか？', sort: 2, },
  { url: `${COLLECTION_ICONS_DIR}icon_collection3.png`, description: '運命の出逢いはこんなかたち', sort: 3, },
  { url: `${COLLECTION_ICONS_DIR}icon_collection4.png`, description: 'あなたの金運を掴む天職', sort: 4, },
  { url: `${COLLECTION_ICONS_DIR}icon_collection5.png`, description: 'あなたの恋と仕事の<br>最適バランス', sort: 6, },
  { url: `${COLLECTION_ICONS_DIR}icon_collection6.png`, description: '苦手なあの人と<br>どう接したらいい？', sort: 5, }
]

export const BASE_DATETIME = new moment('2022/01/01') //※基準年は変えないように注意




// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/commons.js